export class SkechersSizeWiseModel {

    size: string;
    color: string;
    exFactoryDate?: string;
    deliveryDate?: string;
    quantity?: string;

    constructor(
        size: string,
        color: string,
        exFactoryDate?: string,
        deliveryDate?: string,
        quantity?: string,


    ) {

        this.size = size
        this.color = color
        this.exFactoryDate = exFactoryDate
        this.deliveryDate = deliveryDate
        this.quantity = quantity

    };
}